/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge
} from '../../../../Components/Headings';
import HealthCheckLayout from '../../healthCheckLayout/HealthCheckLayout';
import { ProfileCard } from '../../../../Components/Card';
import { SimpleAncerSmall } from '../../../../Components/button';
import img from '../../../../assets/images/svg/doc.svg';
import rightArrow from '../../../../assets/images/svg/right-arrow-white.svg';
import { SimpleSliderSmall } from '../../../../Components/sliders';
import './bookAnAppointment.css';

const cardsData = [
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Prof. Dr. Saira Mustehsan',
    proff: 'Internal Medicine Specialist, Family Physician',
    edu: 'M.B.B.S, F.C.P.S. (Medicine), Ph.D',
    exp: ''
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  }
];

function BookAnAppointment() {
  const items = cardsData.map((card, index) => (
    <ProfileCard card={card} key={index + 1} />
  ));
  return (
    <HealthCheckLayout>
      <section className="bookAnAppointment bgLinghtGray">
        <Container>
          <HeadingWithSpaceLarge text="DOCTOR APPOINTMENT" />
          <HeadingDescSmall text="You have not booked any appointments yet." />

          <SimpleSliderSmall
            className="profileSliderSmall"
            sliderTitle="Top Rated General Physicians"
          >
            {items}
          </SimpleSliderSmall>
          <Row className="btnRow">
            <Col md={10}>
              <SimpleAncerSmall text="browse all our doctors">
                <img src={rightArrow} alt="rightArrow" />
              </SimpleAncerSmall>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default BookAnAppointment;
